import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";

function LinearProgressWithLabel(props) {
  return (
    <div className="d-flex align-items-end">
      <div className="w-100 pt-2 pb-2 mt-1 mr-2 border-right" style={{ height: '26px' }}>
        <LinearProgress variant="determinate" {...props} />
      </div>
      <div style={{ minWidth: '35px' }}>
        <p className="m-0 p-0">Progress</p>
        <h3 className="m-0 p-0">
          {`${Math.round(
            props.value,
          )}%`}
        </h3>
      </div>
    </div>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
});

export default function CLQProgressBar(props) {
  const classes = useStyles();
  React.useEffect(() => {
  }, []);

  return (
    <div className={classes.root}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-10 d-none d-md-block px-2">
            <ProgressBar percent={props.progress}>
              <div style={{ display: 'contents' }}>
                <Step position={0}>
                  {({ accomplished, index }) => (
                    <div id="circle" className={`indexedStep ${accomplished ? "accomplished" : null}`}
                    >
                    </div>
                  )}
                </Step>
              </div>
              <div style={{ display: 'contents' }}>
                <Step position={53}>
                  {({ accomplished, index }) => (
                    <div id="circle" className={`indexedStep ${accomplished ? "accomplished" : null}`}
                    >
                    </div>
                  )}
                </Step>
              </div>
              <div style={{ display: 'contents' }}>
                <Step position={87}>
                  {({ accomplished, index }) => (
                    <div id="circle" className={`indexedStep ${accomplished ? "accomplished" : null}`}
                    >
                    </div>
                  )}
                </Step>
              </div>
              <Step>
                {({ accomplished, index }) => (
                  <div id="line"
                  >
                  </div>
                )}
              </Step>
            </ProgressBar>
          </div>
          <div className="col-md-2 d-none d-md-block">
            <h6>Progress</h6>
            <h4 className="jost-bold">{Math.round(props.progress) + "%"}</h4>
          </div>

          <div className="col-10 d-none d-md-flex progress-sub-content w-100 p-0">
            <h6 style={{ width: '52.5%' }}>ELIGIBILITY</h6>
            <h6 className="home-facts" style={{ width: '33.5%' }}>HOME FACTS</h6>
            <h6>PREFERENCES</h6>
          </div>
        </div>

        <div className="row">
          <div className="col-12 px-0 d-block d-md-none ">
            <h6 className="m-0">Progress</h6>
            <h2 className="jost-bold m-0">{Math.round(props.progress) + "%"}</h2>
          </div>
          <div className="col-12 px-0 d-block d-md-none">
            <ProgressBar percent={props.progress}>
              <Step>
                {({ accomplished, index }) => (
                  <div id="line"
                  >
                  </div>
                )}
              </Step>
            </ProgressBar>
          </div>
        </div>
      </div>
    </div>
  );
}